import _ from 'lodash';
import { hostname } from 'constants/contantsFiles';
import settings from 'constants/settings';
import shareRoutes from './shareRoutes';
import phuongnamRoutes from './phuongnamRoutes';
import heidRoutes from './heidRoutes';

let allRoutes = [];
allRoutes = _.concat(shareRoutes);

if (window.location.hostname === hostname.phuongnam || settings.IS_PREVIEW_SACHSO || settings.IS_VERCEL) {
  allRoutes = _.concat(allRoutes, phuongnamRoutes);
}

if (window.location.hostname === hostname.heid) {
  allRoutes = _.concat(allRoutes, heidRoutes);
}

if (window.location.hostname === hostname.local) {
  allRoutes = _.concat(allRoutes, phuongnamRoutes);
  // allRoutes = _.concat(allRoutes, heidRoutes);
}

export default _.sortBy(allRoutes, ['sortOrder']);
